import React, { Component } from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';

const styles = {
  container: {
    textAlign: 'center',
    marginTop: '50px'
  }
}

class Loader extends Component {
  render() {
    return (
      <div style={styles.container}>
        <CircularProgress />
      </div>
    );
  }
}

export default Loader;



// WEBPACK FOOTER //
// ./src/components/Loader/index.js